import React from "react";
import { Dialog, DialogTitle, DialogActions, DialogContent, Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FormattedMessage } from "react-intl";

interface Props {
	isOpen: boolean;
	onCancel?: () => void;
	onConfirm?: () => void;
	feature: Feature;
}

export enum Feature {
	IMAGE_VIEWER = "image_viewer",
	EMAIL = "email",
}

export const AlertDialog: React.FC<Props> = (props) => {
	const { isOpen, onCancel, onConfirm, feature } = props;
	const classes = useStyles();

	return (
		<Dialog open={isOpen} maxWidth="xs" fullWidth classes={{ paper: classes.mainDialog }}>
			<div className={classes.infoIcon}>
				<Typography variant="h4" className={classes.infoIconText}>
					i
				</Typography>
			</div>
			<DialogTitle className={classes.dialogTitle}>
				<FormattedMessage id="FILE_BROWSER.image_viewer.alert.title" />
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<FormattedMessage id={`FILE_BROWSER.${feature}.alert.description`} />
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				{feature === Feature.EMAIL ? (
					<Button onClick={onCancel} variant="text" className={classes.button}>
						<FormattedMessage id="EMAIL.ok.button" />
					</Button>
				) : (
					<>
						<Button onClick={onCancel} variant="text" className={classes.button}>
							<FormattedMessage id="FILE_BROWSER.image_viewer.button.cancel" />
						</Button>
						<Button onClick={onConfirm} variant="text" className={classes.button}>
							<FormattedMessage id="FILE_BROWSER.image_viewer.button.yes" />
						</Button>{" "}
					</>
				)}
			</DialogActions>
		</Dialog>
	);
};

const useStyles = makeStyles((theme) => {
	return {
		mainDialog: {
			overflowY: "unset",
		},
		dialogTitle: {
			textAlign: "center",
			marginTop: 15,
		},
		dialogContent: {
			textAlign: "justify",
			marginBottom: 30,
			fontSize: 16,
		},
		dialogActions: {
			backgroundColor: "#823BEB99",
		},
		button: {
			textTransform: "none",
			color: "#fff",
			backgroundColor: "#4DAE4F",
			height: 30,
		},
		infoIcon: {
			position: "absolute",
			left: "44.5%",
			top: "-10%",
			width: 50,
			height: 50,
			borderRadius: 50,
			backgroundColor: theme.palette.error.main,
			textAlign: "center",
			padding: 5,
			boxShadow: `0 0 2px 4px ${theme.palette.grey[100]}`,
		},
		infoIconText: {
			color: "#fff",
			fontWeight: 600,
			opacity: "0.8",
		},
	};
});
